import { Parallel } from 'services/api';

export const PRIMARY_SCHOOL_PARALLELS: readonly Parallel[] = [
  Parallel.FIRST,
  Parallel.SECOND,
  Parallel.THIRD,
  Parallel.FOURTH,
];

export const MIDDLE_SCHOOL_PARALLELS: readonly Parallel[] = [
  Parallel.FIFTH,
  Parallel.SIXTH,
  Parallel.SEVENTH,
  Parallel.EIGHTH,
  Parallel.NINTH,
];

export const HIGH_SCHOOL_PARALLELS: readonly Parallel[] = [Parallel.TENTH, Parallel.ELEVENTH];

export type SchoolParallelGroup = {
  label: string;
  parallels: readonly Parallel[];
};

export const SCHOOL_PARALLEL_GROUPS: readonly SchoolParallelGroup[] = [
  { label: 'Начальная школа', parallels: PRIMARY_SCHOOL_PARALLELS },
  { label: 'Средняя школа', parallels: MIDDLE_SCHOOL_PARALLELS },
  { label: 'Старшая школа', parallels: HIGH_SCHOOL_PARALLELS },
];
